import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import SkillItem from "./SkillItem";
import {
 getSkillStoreData,
 
} from "../../../../redux/actions/skill";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/loader";
import { notify } from "../../../../redux/actions/snack";
import EmptyLoader from "../../../../components/emptyLoader";
import navIcon from "../../../../images/nav-icon.svg";
const options = {
  // loop: true,
  margin: 15,
  nav: true,
  navText: [
    `<div class='sk-slide-nav owl-prev'><img src=${navIcon} /></div>`,
    `<div class='sk-slide-nav owl-next'><img src=${navIcon} /></div>`,
  ],
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 3,
    },
  },
};

const AgentHubHome = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [filteredData, setFilteredData] = useState(null);
  const agentHubData = useSelector((state) => state.skillReducer?.aiAgentHubData);
  const activeCategory = useSelector((state) => state.skillReducer?.activeCategory);
  const [isLoading,setIsLoading] = useState(false)

 
useEffect(() => {
    getSkillData();
  }, []);

  useEffect(() => {
    if (agentHubData) {
      filterDataByCategory();
    }
  }, [activeCategory, agentHubData]);

  const getSkillData = async () => {
    setIsLoading(true);
    try {
      await dispatch(getSkillStoreData());
      setIsLoading(false);
    } catch (err) {

      setIsLoading(false);
      console.error("Error fetching agent hub data:", err);
    } 
  };

  const filterDataByCategory = () => {
    
    try {
      if (activeCategory !== "All") {
        const filteredResults = agentHubData.results.filter(
          item => item.category === activeCategory
        );
        
        setFilteredData({
          ...agentHubData,
          results: filteredResults
        });

      } else {
        setFilteredData(agentHubData);

      }
    } catch (err) {
      console.error("Error filtering data:", err);
    } 
  };

  return (
    <div>
        {isLoading?<Loader/>:filteredData?.results?.length===0?<EmptyLoader message="No agents found"/>:
        <>
         {filteredData?.results?.length && filteredData?.results?.map((item) => (
        <div className="sk-slide-section">
          <div className="sk-slide-title">
            <h4 className="tp-title">{item?.category}</h4>
            {item?.skills?.length > 4 ? (
              <a
                onClick={() => {
                  history.push(
                    `/dashboard/skill-store/skill-collection/${item.category}`
                  );
                }}
              >
                View all
              </a>
            ) : (
              ""
            )}
          </div>
          <OwlCarousel
            className="owl-theme sk-boxes"
            id="sk-boxes1"
            {...options}
          >
            {item?.skills?.map((skill, index) => (
              <SkillItem item={skill} key={index} opt={false} />
            ))}
          </OwlCarousel>
        </div>
      ))}</>
     
      }
    </div>
  );
};

export default AgentHubHome;
